import React, { useEffect, useState } from 'react';
import {
    BringzzPageContainer,
    BringzzIcon,
    BringzzButton
} from '@bringzz/components';
import { useNavigation } from 'context/NavigationContext';
import { useOrder } from 'context/OrderContext';
import ProductScanDisplay from 'components/ProductScanDisplay';
import { DELIVERY_TYPES } from 'utils/constants';
const PrescriptionValidPage = () => {
    const { backPress, navigate } = useNavigation();
    const { orderDetails, resetOrderContext } = useOrder();
    const [currentProductIndex, setCurrentProductIndex] = useState(0);

    useEffect(() => {
        if (!orderDetails) {
            resetOrderContext();
            navigate('/home');
        }
    }, [orderDetails, navigate, resetOrderContext]);

    const handleContinue = () => {
        const products = orderDetails?.products || [];
        if (currentProductIndex < products.length - 1) {
            setCurrentProductIndex(currentProductIndex + 1);
        } else {
            // All products viewed, navigate to next step
            const instructions = "PACKAGE_ORDER_PROCESSING_SCANNING_INSTRUCTIONS"
            let nextStep = `/camera/pharmacy/pickup/bag`;
            if (orderDetails?.type == DELIVERY_TYPES.CLICK_AND_COLLECT) {
                nextStep = `/camera/pharmacy/collect/bag`;
            } else if (orderDetails?.type == DELIVERY_TYPES.MAIL_DELIVERY) {
                nextStep = `/camera/pharmacy/mail/bag`;
            }
            navigate('/instruction', {
                state: {
                    instructions,
                    nextStep
                }
            });
        }
    };

    const handleProductContinue = (products) => {
        // This is called when all products are viewed
        const instructions = "PACKAGE_ORDER_PROCESSING_SCANNING_INSTRUCTIONS"
        let nextStep = `/camera/pharmacy/pickup/bag`;
        if (orderDetails?.type == DELIVERY_TYPES.CLICK_AND_COLLECT) {
            nextStep = `/camera/pharmacy/collect/bag`;
        } else if (orderDetails?.type == DELIVERY_TYPES.MAIL_DELIVERY) {
            nextStep = `/camera/pharmacy/mail/bag`;
        }
        navigate('/instruction', {
            state: {
                instructions,
                nextStep
            }
        });
    };

    const products = orderDetails?.products || [];
    
    return (
        <BringzzPageContainer
            className="h-full flex flex-col"
            header={{
                left: <BringzzIcon
                    size="18"
                    icon="IconClose"
                    folder="LineIcons"
                    className="cursor-pointer"
                    onClick={backPress}
                />,
                title: "Verify Order"
            }}
            footer={
                <div className="flex justify-center p-4">
                    <BringzzButton
                        size="lg"
                        className="bg-magic-lilac w-full flex justify-center text-midnight-blue rounded-full font-semibold"
                        onClick={handleContinue}
                    >
                        {currentProductIndex < products.length - 1 
                            ? `Continue (${products.length - currentProductIndex - 1} more)`
                            : 'Continue'
                        }
                    </BringzzButton>
                </div>
            }
            footerHover={true}
        >
            <ProductScanDisplay
                title="Scanned Products"
                onContinue={handleProductContinue}
                currentProductIndex={currentProductIndex}
                setCurrentProductIndex={setCurrentProductIndex}
            />
        </BringzzPageContainer>
    );
};

export default PrescriptionValidPage;
